import Vue from 'vue';

Vue.component('app-date-select', () => import('@/components/shared/app-date-select.vue'));
Vue.component('app-select', () => import('@/components/shared/app-select.vue'));
Vue.component('app-input-text', () => import('@/components/shared/app-input-text.vue'));
Vue.component('app-tooltip-button', () => import('@/components/shared/app-tooltip-button.vue'));
Vue.component('app-date-mask', () => import('@/components/shared/app-date-mask.vue'));
Vue.component('layouts-slide-container', () => import('@/layouts/layouts-slide-container.vue'));



// WEBPACK FOOTER //
// ./src/config.js